/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_IntegrationsInputs */

const en_mk_cmp_integrations = /** @type {(inputs: Mk_Cmp_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All integrations`)
};

const id_mk_cmp_integrations = /** @type {(inputs: Mk_Cmp_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua integrasi`)
};

/**
* | output |
* | --- |
* | "All integrations" |
*
* @param {Mk_Cmp_IntegrationsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_integrations = /** @type {((inputs?: Mk_Cmp_IntegrationsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_IntegrationsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_integrations(inputs)
	return en_mk_cmp_integrations(inputs)
});